import {
  DateTime,
  LabelColor,
  StyledTag,
  TextEllipsis,
} from '@aibees/shared/components';
import { Invoice, InvoiceStatus } from '@aibees/shared/definition';
import { AdvanceTableConfig } from '@aibees/shared/features';
import { useBrowseInvoiceApi } from '@aibees/shared/features/billing-profile/api/use-browse-invoice-api';
import { Stack, Typography } from '@mui/material';
import { DownloadInvoiceAction } from './actions/download-invoice-action';

const stateColor: { [key: string]: LabelColor } = {
  [InvoiceStatus.draft]: 'primary',
  [InvoiceStatus.uncollectible]: 'error',
  [InvoiceStatus.paid]: 'success',
};

export const config: AdvanceTableConfig<Invoice> = {
  hideColumnsOnNoData: true,
  sequentialPagination: true,
  columns: [
    {
      id: 'id',
      label: 'Invoice ID',
      width: '25%',
      render: (v) => <TextEllipsis value={v} w="25vw" variant="body3" />,
    },
    {
      id: 'created',
      label: 'Payment Date',
      render: (v) => (
        <Stack direction="row">
          <DateTime value={v} noTime />
        </Stack>
      ),
      width: '10%',
    },
    {
      id: 'subscription',
      label: 'Subscription',
      render: (v) => <Typography variant="body3">{v}</Typography>,
      width: '15%',
    },
    {
      id: 'total',
      label: 'Amount',
      width: '10%',
      render: (v) => <Typography variant="body3">{`$${v / 100}`}</Typography>,
    },
    {
      id: 'status',
      label: 'Status',
      width: '15%',
      render: (v) => (
        <StyledTag
          color={stateColor[v]}
          fullWidth
          label={v.charAt(0).toUpperCase() + v.slice(1)}
          size="small"
        />
      ),
    },
  ],
  actions: [DownloadInvoiceAction],
  actionsConfig: {
    label: 'Download',
    width: '10%',
    sx: { display: 'flex', justifyContent: 'center' },
  },
  filters: [],
  browseApi: useBrowseInvoiceApi,
  showJumpToPage: false,
  showTablePrependOnNotFound: true,
  emptyProps: {
    content: '',
  },
  bordered: 'solid',
};
